export default __webpack_public_path__ + "static/media/getKampus.80d098f1.png";